import { useEffect, useMemo, useState } from 'react';
import './styles.css';
import {
  addNewCalculationSession,
  deleteSavedCalculation,
  editSavedCalculation,
} from '../../../redux/Calculations/CalculationsActions';
import Box from '@mui/material/Box';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {
  AcceptRejectDialog,
  NotificationDialog,
  PopUpSpinner,
} from '../../CommonFunctions/DialogComponents';
import { createSvgIcon, IconButton, List, Stack, Tooltip, Typography } from '@mui/material';
import { Box as CustomBox } from '../../DataViewer/Box';
import { fontSize } from '../../..';
import { deleteItemInChartProp } from '../../../redux/ChartPoperties/ChartPropertiesActions';
import { getNameFor } from '../utils';
import ShowSavedParameters from '../../Parameters/ShowSavedParameters';
import {
  removeCalculationId,
  resetParameterSession,
  syncParameterData,
} from '../../../redux/Parameters/ParametersAction';
import { fetchMinMax, fetchUniqueOptions } from '../../../api/filters';
import { getDataSetDetail } from '../../../api';
import { useSelector, useDispatch } from 'react-redux';
import { Add } from '@mui/icons-material';
import { RootState } from '../../../redux';
import { checkIfMissingColumn } from '../../CommonFunctions/CommonFunctions';
import { TabTilPropsSelectedDatasetList } from '../../../redux/TabTile/TabTilePropsInterfaces';
import { MinMaxPayload } from '../../../redux/Parameters/ParameterInterface';

const AddFunctionIcon = createSvgIcon(
  <svg
    width="100"
    height="103"
    viewBox="0 0 100 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.6652 96.08C29.1652 96.08 27.8752 95.63 26.7952 94.73C25.7152 93.89 25.2352 92.15 25.3552 89.51C25.4752 86.57 25.6852 83.51 25.9852 80.33C26.2852 77.15 26.6152 74.18 26.9752 71.42C27.7552 65.36 27.9352 60.68 27.5152 57.38C27.1552 54.02 26.2252 51.62 24.7252 50.18C23.2852 48.74 21.3352 47.78 18.8752 47.3C17.6752 47.06 16.7152 46.61 15.9952 45.95C15.2752 45.23 14.9152 44.3 14.9152 43.16C14.9152 41.66 15.5152 40.67 16.7152 40.19C17.8552 39.71 19.3252 39.47 21.1252 39.47C22.5052 39.47 24.2752 39.56 26.4352 39.74C28.6552 39.86 31.0252 39.95 33.5452 40.01C35.6452 33.11 38.0152 27.41 40.6552 22.91C43.2952 18.41 46.1752 14.87 49.2952 12.29C52.4152 9.65 55.7152 7.82 59.1952 6.8C62.6752 5.71999 66.2752 5.17999 69.9952 5.17999C74.6152 5.17999 76.9252 6.82999 76.9252 10.13C76.9252 11.75 76.1452 12.98 74.5852 13.82C73.0252 14.66 70.6552 15.35 67.4752 15.89C63.6952 16.55 60.3652 17.78 57.4852 19.58C54.6652 21.38 52.1752 23.93 50.0152 27.23C47.9152 30.53 46.0552 34.79 44.4352 40.01C52.7752 39.83 59.6152 39.38 64.9552 38.66C70.2952 37.94 74.4052 37.25 77.2852 36.59C80.2252 35.87 82.2652 35.51 83.4052 35.51C85.0252 35.51 86.0152 35.9 86.3752 36.68C86.7952 37.46 87.0052 38.3 87.0052 39.2C87.0052 40.22 86.0452 41.27 84.1252 42.35C82.8652 43.07 80.8552 43.88 78.0952 44.78C75.3352 45.62 72.0952 46.46 68.3752 47.3C64.6552 48.08 60.7252 48.74 56.5852 49.28C52.5052 49.76 48.5152 50 44.6152 50C43.6552 50 42.7852 50 42.0052 50C41.3452 53.48 40.6852 57.17 40.0252 61.07C39.4252 64.91 38.8852 68.66 38.4052 72.32C37.9252 75.98 37.5052 79.31 37.1452 82.31C36.8452 85.31 36.6652 87.71 36.6052 89.51C36.5452 91.73 35.9752 93.38 34.8952 94.46C33.8152 95.54 32.4052 96.08 30.6652 96.08Z"
      fill="#2BB9BB"
    />
    <path
      d="M50.5513 89.72C49.5273 89.72 48.7806 89.3787 48.3113 88.696C47.8419 87.9707 47.6499 87.0747 47.7353 86.008C47.7779 85.4107 48.2473 84.5573 49.1433 83.448C50.0393 82.296 51.2126 80.952 52.6633 79.416C54.1139 77.8373 55.7139 76.152 57.4633 74.36C59.2553 72.5253 61.0899 70.6693 62.9673 68.792C60.6206 65.336 58.8499 62.5627 57.6553 60.472C56.5033 58.3813 55.8846 56.7387 55.7993 55.544C55.7139 54.2213 55.9273 53.1547 56.4393 52.344C56.9939 51.5333 57.8686 51.128 59.0633 51.128C59.7459 51.128 60.4499 51.448 61.1753 52.088C61.9433 52.728 62.9033 53.9013 64.0553 55.608C65.2499 57.3147 66.8286 59.7253 68.7913 62.84C71.7353 59.896 74.1459 57.5067 76.0233 55.672C77.9433 53.7947 79.4793 52.344 80.6313 51.32C81.8259 50.296 82.7433 49.592 83.3833 49.208C84.0659 48.824 84.6419 48.632 85.1113 48.632C86.1353 48.632 86.8606 48.9947 87.2873 49.72C87.7566 50.4027 87.9486 51.2987 87.8633 52.408C87.7779 53.304 87.2446 54.392 86.2633 55.672C85.3246 56.9093 84.1086 58.2747 82.6153 59.768C81.1219 61.2187 79.5006 62.7333 77.7513 64.312C76.0446 65.848 74.3806 67.3627 72.7593 68.856C75.4046 72.6107 77.8793 75.896 80.1833 78.712C82.5299 81.4853 84.4286 83.7893 85.8793 85.624C87.3299 87.416 88.0766 88.7387 88.1193 89.592C88.2046 90.488 87.9699 91.192 87.4153 91.704C86.9033 92.216 86.1566 92.472 85.1753 92.472C84.6206 92.472 83.9379 92.28 83.1273 91.896C82.3166 91.512 81.2286 90.7227 79.8633 89.528C78.5406 88.3333 76.8339 86.5413 74.7433 84.152C72.6953 81.72 70.1353 78.456 67.0633 74.36C65.3139 76.152 63.5646 77.944 61.8153 79.736C60.1086 81.528 58.4873 83.192 56.9513 84.728C55.4579 86.2213 54.1353 87.4373 52.9833 88.376C51.8739 89.272 51.0633 89.72 50.5513 89.72Z"
      fill="#AF98DB"
    />
  </svg>,
  'AddFunction',
);

// refactored this component to use redux instead of connect and replaced the functions with dispatch calls
const SavedCalculationsHolder = ({ propKey }: { propKey: string }) => {
  const { calculations, chartProperties, parameters, tabTileProps } = useSelector(
    (state: RootState) => {
      return {
        calculations: state.calculations,
        chartProperties: state.chartProperties,
        tabTileProps: state.tabTileProps,
        parameters: state.parameters,
      };
    },
  );

  const dispatch = useDispatch();

  const [showSavedCalculations, setSavedCalculations] = useState(false);
  const [showSavedParameters, setSavedParameters] = useState(false);
  const [alert, setAlert] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState<any>({});
  const [isCreatingCalculation, setIsCreatingCalculation] = useState(false);

  const [warningCalculation, setWarningCalculation] = useState<{
    [key: string]: boolean;
  }>({});

  const realSelectedDatasetId = useMemo(() => {
    return chartProperties?.properties[propKey]?.selectedDs?.id;
  }, [
    chartProperties?.properties[propKey]?.selectedDs,
    chartProperties?.properties[propKey]?.oldSelectedDs,
  ]);
  const vendor = chartProperties.properties[propKey]?.selectedDs?.vendor;

  const savedCalculationList = useMemo(() => {
    return calculations?.savedCalculations?.filter(
      (calculation: any) =>
        calculation.datasetId === realSelectedDatasetId && calculation.isAggregated,
    );
  }, [calculations?.savedCalculations, realSelectedDatasetId]);

  const currentCalculationSession = calculations?.properties[propKey]?.currentCalculationSession;
  const currentParameterSession = parameters?.properties[propKey]?.parameterSession;

  const selectedDs = useMemo(() => {
    return chartProperties?.properties[propKey]?.selectedDs;
  }, [
    chartProperties?.properties[propKey]?.selectedDs,
    chartProperties?.properties[propKey]?.oldSelectedDs,
  ]);

  const handleCreateCalculation = (e: any) => {
    if (currentCalculationSession) {
      setAlert({
        severity: 'warning',
        message: 'Either save or close the current calculation before creating a new calculation',
      });
      return;
    }

    if (currentParameterSession && !isCreatingCalculation) {
      setOpen(true);
      return;
    }

    // const calculationName = generateCalculationName(
    //   calculations?.savedCalculations,
    //   ['oracle', 'snowflake'].includes(vendor),
    // );
    // dispatch(addNewCalculationSession(propKey, calculationName, realSelectedDatasetId));
    createCalculationSession();
  };

  const createCalculationSession = () => {
    const calculationName = getNameFor(
      'calculation',
      calculations?.savedCalculations,
      ['oracle', 'snowflake'].includes(vendor),
    );
    dispatch(addNewCalculationSession(propKey, calculationName, realSelectedDatasetId));
  };

  useEffect(() => {
    if (isCreatingCalculation && !currentParameterSession) {
      setIsCreatingCalculation(false);
      createCalculationSession();
    }
  }, [isCreatingCalculation, currentParameterSession]);

  const deleteItemFromChartFunc = (propKey: string, binIndex: number, itemIndex: number) => {
    dispatch(deleteItemInChartProp(propKey, binIndex, itemIndex));
  };

  const deleteCalculation = (calculation: any) => {
    if (
      currentCalculationSession &&
      currentCalculationSession?.uuid &&
      calculation.calculationInfo.calculatedFieldName ===
        currentCalculationSession?.calculationInfo?.calculatedFieldName
    ) {
      setAlert({
        severity: 'warning',
        message: 'Either save or close the current calculation before deleting the calculation',
      });
      return;
    }
    const flows = Object.keys(calculation.calculationInfo.flows);
    flows.forEach((flow: any) => {
      const parameters = calculation.calculationInfo.flows[flow][0].parameter;
      if (parameters && parameters.length > 0) {
        parameters.forEach((parameter: any) => {
          dispatch(removeCalculationId(calculation.uuid, parameter.parameterId));
        });
      }
    });

    dispatch(deleteSavedCalculation(calculation.calculationInfo.calculatedFieldName, propKey));
  };

  const handleEditCalculation = (calculation: any) => {
    if (currentCalculationSession) {
      setAlert({
        severity: 'warning',
        message: 'Either save or close the current calculation before editing another calculation',
      });
      return;
    }

    if (currentParameterSession) {
      setAlert({
        severity: 'warning',
        message:
          'You have an unsaved parameter session open. Please save or close your current parameter session before editing or creating a calculation',
      });
      return;
    }

    dispatch(editSavedCalculation(propKey, calculation.calculationInfo.calculatedFieldName));
  };

  const renderInBlocks = (arr: any[], blockSize: number) => {
    if (!arr || arr.length === 0) return [];
    const blocks = [];
    for (let i = 0; i < arr.length; i += blockSize) {
      blocks.push(arr.slice(i, i + blockSize));
    }
    return blocks;
  };

  const renderBlocks = renderInBlocks(savedCalculationList, 4);

  const handleAcceptChanges = () => {
    setLoading(true);

    try {
      setIsCreatingCalculation(true);
      dispatch(resetParameterSession(propKey));
      setOpen(false);
      setLoading(false);
    } catch (error) {
      setIsCreatingCalculation(false);
      setAlert({
        severity: 'error',
        message: 'Failed to reset parameter session. Please try again.',
      });
      console.error('Error resetting parameter session:', error);
    }
  };

  const handleLoadParameter = async (parameterId: string) => {
    const workspaceId = tabTileProps.selectedDataSetList[0]?.workSpaceId;

    const parameter = parameters?.savedParameters.find(
      (parameter: any) => parameter.parameterId === parameterId,
    );

    const columns = parameter?.columns;
    if (!columns) return;

    const payload: MinMaxPayload = {
      tableId: columns.tableId,
      fieldName: columns.fieldName,
      dataType: columns.dataType === 'number' ? 'integer' : columns.dataType,
      filterOption: 'allValues',
      timeGrain: columns.dataType === 'date' ? 'date' : 'year',
    };

    if (columns?.calculatedFieldId && columns.has_calculation) {
      const calc = calculations.savedCalculations.find(
        (calculation) => calculation.uuid === columns.calculatedFieldId,
      );

      if (!calc) {
        console.error(`Calculation not found for ID: ${columns.calculatedFieldId}`);
        return;
      }

      payload.isCalculatedField = columns.has_calculation;
      payload.calculatedField = [
        {
          calculatedFieldName: calc!.calculationInfo.calculatedFieldName ?? '',
          fields: calc!.calculationInfo.fields,
          flows: calc!.calculationInfo.flows,
          conditionFilters: calc!.calculationInfo.conditionFilters,
          overrided: calc!.calculationInfo.overrideCount > 0,
        },
      ];
    }

    const res = await fetchUniqueOptions(
      tableData?.connectionId || '',
      realSelectedDatasetId,
      workspaceId,
      payload,
    );
    const result = res.data;

    let minValue = parameter.minValue;
    let maxValue = parameter.maxValue;

    if (result && result.length > 0 && parameter.columns.dataType !== 'text') {
      const { min, max } = await minMax(payload, workspaceId);
      minValue = min[0];
      maxValue = max[0];
    }

    if (parameter.loadDefaultValue) {
      dispatch(
        syncParameterData(
          parameterId,
          result,
          Number(minValue),
          Number(maxValue),
          Number(parameter.stepValue),
          parameter.columns.defaultValue as any,
        ),
      );
      return;
    }
    dispatch(
      syncParameterData(
        parameterId,
        result,
        Number(minValue),
        Number(maxValue),
        Number(parameter.stepValue),
      ),
    );
  };

  const minMax = async (payload: MinMaxPayload, workspaceId: string) => {
    const res = await fetchMinMax(
      tableData?.connectionId || '',
      realSelectedDatasetId,
      workspaceId,
      { ...payload, filterOption: 'minMax' },
    );
    return extractMinMax(res.data);
  };

  // to convert the min max property to lower case because the snowflake returns the min max in upper case
  function extractMinMax(obj: any) {
    let min, max;

    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const lowerKey = key.toLowerCase();
        if (lowerKey === 'min') {
          min = obj[key];
        } else if (lowerKey === 'max') {
          max = obj[key];
        }
      }
    }

    return { min, max };
  }

  const isColumnMissing = async () => {
    let warnCalculations: {
      [key: string]: boolean;
    } = {};
    const savedCalculations = calculations?.savedCalculations || [];
    const promises = savedCalculations.map(async (calc) => {
      const fields = calc.calculationInfo?.fields;
      if (!fields) return;
      const results = await Promise.all(
        Object.keys(fields).map((fieldKey) =>
          checkIfMissingColumn(
            fields[fieldKey],
            selectedDs,
            tabTileProps.tablesForSelectedDataSets[selectedDs.id],
          ),
        ),
      );
      warnCalculations = {
        ...warnCalculations,
        [calc.uuid!]: results.some((res) => res.isMissing),
      };
    });
    await Promise.all(promises);
    setWarningCalculation(warnCalculations);
  };

  const handleTableData = async () => {
    const workspaceId = tabTileProps.selectedDataSetList.find(
      (ds: TabTilPropsSelectedDatasetList) => ds.id === realSelectedDatasetId,
    )?.workSpaceId;
    const response = await getDataSetDetail(realSelectedDatasetId, workspaceId);
    const dataSetResponse = response.data;
    setTableData(dataSetResponse);
  };

  const getContainerWidth = () => {
    if (!showSavedCalculations && !showSavedParameters) {
      return '3.5rem';
    }
    if (showSavedParameters) {
      const columnCount = Math.ceil(parameters.savedParameters.length / 4);
      if (columnCount <= 1) {
        return '15.625rem';
      }

      const columnWidth = 13;
      const gapWidth = 0.75;
      const paddingWidth = 1;

      if (columnCount === 3) {
        const totalWidth = columnCount * columnWidth + (columnCount - 1) * gapWidth + paddingWidth;
        return `${totalWidth}rem`;
      }

      if (columnCount === 2) {
        const totalWidth = columnCount * columnWidth + (columnCount - 1) * gapWidth + paddingWidth;
        return `${totalWidth + 1.5}rem`;
      }

      const totalWidth = 3 * columnWidth + 1 * gapWidth + paddingWidth + 0.5;
      return `${totalWidth}rem`;
    }

    if (showSavedCalculations) {
      const columnCount = Math.ceil(savedCalculationList.length / 4);
      if (columnCount <= 1) {
        return '15.625rem';
      }

      const columnWidth = 13;
      const gapWidth = 0.75;
      const paddingWidth = 1;

      if (columnCount === 3) {
        const totalWidth = columnCount * columnWidth + (columnCount - 1) * gapWidth + paddingWidth;
        return `${totalWidth}rem`;
      }

      if (columnCount === 2) {
        const totalWidth = columnCount * columnWidth + (columnCount - 1) * gapWidth + paddingWidth;
        return `${totalWidth + 1.5}rem`;
      }

      const totalWidth = 3 * columnWidth + 1 * gapWidth + paddingWidth + 0.5;
      return `${totalWidth}rem`;
    }

    return '15.625rem';
  };

  useEffect(() => {
    isColumnMissing();
  }, [calculations?.savedCalculations]);

  useEffect(() => {
    handleTableData();
  }, []);

  useEffect(() => {
    if (!tableData || Object.keys(tableData).length <= 0) return;
    parameters.savedParameters.forEach((parameter: any) => {
      if (
        (parameter.loadFromColumn || parameter.loadDefaultValue) &&
        !parameter.columns.displayType.includes('input')
      ) {
        handleLoadParameter(parameter.parameterId);
      }
    });
  }, [tableData]);

  return (
    <div
      style={{
        width: getContainerWidth(),
        maxWidth: getContainerWidth(),
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        flexShrink: '0',
        flexWrap: 'nowrap',
        overflowX: 'hidden',
        overflowY: 'hidden',
      }}
    >
      {showSavedParameters && <ShowSavedParameters />}
      {showSavedCalculations && (
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            width: '100%',
            flexDirection: 'column',
            borderLeft: '2px solid rgba(224, 224, 224, 1)',
            overflow: 'hidden',
            maxWidth: getContainerWidth(),
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
              px: '0.75rem',
              pt: '0.55rem',
              pb: 0,
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                color: 'primary.contrastText',
                fontSize: fontSize.large,
                flexShrink: 0,
              }}
            >
              Formula Measures
            </Typography>
            <Tooltip title={<span style={{ fontSize: '12px' }}>New formula</span>}>
              <IconButton
                onClick={handleCreateCalculation}
                sx={{
                  color: '#2BB9BB',
                  backgroundColor: '#fff',
                  padding: '0.2rem',
                  borderRadius: '50%',
                  boxShadow: '0 2px 8px rgba(43, 185, 187, 0.15)',
                  transition: 'background 0.2s, box-shadow 0.2s',
                  outline: '1px solid #2BB9BB',
                  '&:hover': {
                    boxShadow: '0 4px 12px rgba(43, 185, 187, 0.25)',
                    backgroundColor: '#2BB9BB',
                    color: '#fff',
                    outline: '1px solid #2BB9BB',
                  },
                  '& .MuiSvgIcon-root': {
                    fontSize: '14px',
                  },

                  '&:focus-visible': {
                    outline: '2px solid #2BB9BB',
                  },
                }}
                size="small"
              >
                <Add fontSize="inherit" />
              </IconButton>
            </Tooltip>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              overflow: 'hidden',
              minHeight: 0,
              width: '100%',
              ml: '0.25rem',
              position: 'relative',
              pb: 0,
            }}
          >
            <List
              sx={{
                width: '100%',
                flexGrow: 1,
                overflowY: 'hidden',
                overflowX: renderBlocks.length > 3 ? 'auto' : 'hidden',
                minHeight: 0,
                px: '0.5rem',
                pl: savedCalculationList.length < 5 ? '0.1rem' : '0.5rem',
                pb: 0,
                m: 0,
                scrollMarginTop: '12px',
                '&::-webkit-scrollbar': {
                  width: '6px',
                  height: '6px',
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: '#ccc',
                  borderRadius: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  backgroundColor: '#f1f1f1',
                  borderRadius: '8px',
                },
              }}
            >
              {savedCalculationList.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-around',
                    height: '100%',
                    p: '1rem',
                  }}
                >
                  <Typography
                    sx={{
                      color: '#5d5c5c',
                      fontSize: fontSize.medium,
                      width: '100%',
                      textAlign: 'center',
                      mb: '1rem',
                    }}
                  >
                    No saved formula measures in the dataset{' '}
                    <Box
                      component="span"
                      sx={{
                        maxWidth: '7rem',
                        display: 'inline-block',
                        verticalAlign: 'middle',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                      title={chartProperties?.properties[propKey]?.selectedDs?.datasetName}
                    >
                      {chartProperties?.properties[propKey]?.selectedDs?.datasetName}
                    </Box>
                  </Typography>
                </Box>
              ) : (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '0.5rem',
                    p: 0,
                    pr: '0.45rem',
                    minWidth: '100%',
                    height: '100%',
                    overflowY: 'hidden',
                    overflowX: renderBlocks.length > 3 ? 'visible' : 'hidden',
                    scrollMarginTop: '12px',
                    '&::-webkit-scrollbar': {
                      width: '6px',
                      height: '6px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#ccc',
                      borderRadius: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#f1f1f1',
                      borderRadius: '8px',
                    },
                  }}
                >
                  {renderBlocks.map((block: any[], blockIndex: number) => (
                    <Box
                      key={blockIndex}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.5rem',
                        minWidth: savedCalculationList.length > 4 ? '11.8rem' : '100%',
                        flexShrink: 0,
                        height: 'fit-content',
                      }}
                    >
                      {block.map((calculation: any) => {
                        let isCalculationPresentInChartAxes = false;

                        const informationForPropDeletion: {
                          [key: string]: {
                            binIndex: number;
                            fieldIndex: number;
                          }[];
                        } = {};

                        const allPropKeys = Object.keys(chartProperties?.properties);

                        for (const eachPropKey of allPropKeys) {
                          chartProperties?.properties[eachPropKey]?.chartAxes?.forEach(
                            (ax: any, axId: number) => {
                              ax?.fields?.forEach((field: any, fieldId: number) => {
                                if (field.SavedCalculationUUID) {
                                  if (!informationForPropDeletion[eachPropKey]) {
                                    informationForPropDeletion[eachPropKey] = [];
                                  }
                                  informationForPropDeletion[eachPropKey].push({
                                    binIndex: axId,
                                    fieldIndex: fieldId,
                                  });
                                  isCalculationPresentInChartAxes =
                                    field.SavedCalculationUUID === calculation.uuid;
                                }
                              });
                            },
                          );
                        }

                        return (
                          <Box
                            key={calculation.uuid}
                            sx={{
                              width: '100%',
                              // height: 'fit-content',

                              overflow: 'hidden',
                            }}
                          >
                            <CustomBox
                              name={
                                calculation.calculationInfo.displayFieldName ??
                                calculation.calculationInfo.calculatedFieldName
                              }
                              type="calculation"
                              warning={warningCalculation[calculation.uuid] || false}
                              informationForPropDeletion={informationForPropDeletion}
                              isPresentInAxes={isCalculationPresentInChartAxes}
                              fieldData={{
                                dataType: calculation.datatype,
                                displayname:
                                  calculation.calculationInfo.displayFieldName ??
                                  calculation.calculationInfo.calculatedFieldName,
                                fieldname: calculation.calculationInfo.calculatedFieldName,
                                tableId:
                                  calculation.calculationInfo.fields[
                                    Object.keys(calculation.calculationInfo.fields)[0]
                                  ].tableId,
                                uId: calculation.calculationInfo.fields[
                                  Object.keys(calculation.calculationInfo.fields)[0]
                                ].uId,
                                isCalculatedField: true,
                                isAggregated: true,
                              }}
                              isSavedCalculation={true}
                              colsOnly={true}
                              handleEditButton={() => handleEditCalculation(calculation)}
                              deleteIfPresentInAxes={deleteItemFromChartFunc}
                              handleDeleteButton={() => deleteCalculation(calculation)}
                              allSavedCalculations={savedCalculationList}
                            />
                          </Box>
                        );
                      })}
                    </Box>
                  ))}
                </Box>
              )}
            </List>
          </Box>
        </Box>
      )}
      <Box
        sx={{
          width: '3.5rem',
          flexShrink: '0',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'white',
          borderLeft: '2px solid rgba(224, 224, 224, 1)',
          zIndex: 1,
          py: '0.5rem',
        }}
      >
        <Tooltip
          title={`${showSavedCalculations ? 'Hide' : 'Open'} Formula Builder`}
          slotProps={{
            tooltip: {
              className: 'tooltip-font',
            },
          }}
        >
          <IconButton
            sx={{
              backgroundColor: showSavedCalculations ? 'rgba(43, 185, 187, 0.2)' : 'transparent',
              '&:hover': {
                backgroundColor: showSavedCalculations
                  ? 'rgba(43, 185, 187, 0.2)'
                  : 'rgba(0, 0, 0, 0.04)',
              },
              padding: '0.4rem',
              height: '2.275rem',
              width: '2.275rem',
              borderRadius: '50%',
            }}
            onClick={() => {
              setSavedCalculations((prev) => !prev);
              setSavedParameters(false);
            }}
          >
            <AddFunctionIcon fontSize="large" />
          </IconButton>
        </Tooltip>
        <Tooltip
          title={`${showSavedParameters ? 'Hide' : 'Show'} Saved Parametres`}
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          <IconButton
            sx={{
              backgroundColor: showSavedParameters ? 'rgba(43, 185, 187, 0.2)' : 'transparent',
              '&:hover': {
                backgroundColor: showSavedParameters
                  ? 'rgba(43, 185, 187, 0.2)'
                  : 'rgba(0, 0, 0, 0.04)',
              },
              padding: '0.65rem',
            }}
            onClick={() => {
              setSavedCalculations(false);
              setSavedParameters((prev) => !prev);
            }}
          >
            <img src="/Parameter_icon.svg" alt="parameter-icon" style={{ height: '1.4rem' }} />
          </IconButton>
        </Tooltip>
        {showSavedCalculations || showSavedParameters ? (
          <Tooltip
            title="Collapse"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <KeyboardArrowRightIcon
              onClick={() => {
                setSavedCalculations(false);
                setSavedParameters(false);
              }}
              style={{
                cursor: 'pointer',
                color: 'rgb(133, 133, 133)',
              }}
            />
          </Tooltip>
        ) : (
          <Tooltip
            title="Expand"
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '12px',
                },
              },
            }}
          >
            <KeyboardArrowLeftIcon
              onClick={() => {
                setSavedCalculations(true);
                setSavedParameters(false);
              }}
              style={{ cursor: 'pointer', color: 'rgb(133, 133, 133)' }}
            />
          </Tooltip>
        )}
      </Box>
      {alert && (
        <NotificationDialog
          severity={alert.severity}
          openAlert={alert}
          onCloseAlert={() => setAlert(null)}
          testMessage={alert.message}
        />
      )}
      {loading && <PopUpSpinner show={loading} />}
      <AcceptRejectDialog
        open={open}
        closeFunction={() => setOpen(false)}
        acceptFunction={handleAcceptChanges}
        heading="PARAMETER IN PROGRESS"
        messages={[
          {
            text: 'You have an unsaved parameter session open. If you proceed, the current parameter will be discarded. Do you want to proceed?',
          },
        ]}
        rejectFunction={() => setOpen(false)}
        acceptText="Yes"
        rejectText="No"
      />
    </div>
  );
};

export default SavedCalculationsHolder;
